<template>
  <div>
    <el-table :data="dataList" :key="tableKey" style="width: 100%">
      <el-table-column type="index" align="center" label="序号" width="50" />
      <el-table-column prop="courceName" align="center" label="课程标题" />
      <el-table-column prop="teacherName" align="center" label="讲师" />
      <el-table-column
        prop="courseCategoryName"
        align="center"
        label="课程分类"
      />
      <el-table-column align="center" label="操作">
        <template #default="{ $index }">
          <el-popconfirm title="是否要删除?" @confirm="onRowDelete($index)">
            <template #reference>
              <el-button size="small" type="danger">删除</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Sortable from "sortablejs";
export default {
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableKey: 0,
    };
  },
  created() {
    this.$nextTick(() => {
      this.rowDrop();
    });
  },
  methods: {
    onRowDelete(index) {
      this.$emit("delete", index);
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        draggable: ".el-table__row",
        onEnd({ newIndex, oldIndex }) {
          const oldItem = _this.dataList[oldIndex];
          const newItem = _this.dataList[newIndex];
          _this.dataList[newIndex] = oldItem;
          _this.dataList[oldIndex] = newItem;
          _this.dataList.map((item, index) => (item.sort = index));
          _this.tableKey += 1;
          _this.$nextTick(() => {
            _this.rowDrop();
          });
        },
      });
    },
  },
};
</script>

<style>
</style>